import { render, staticRenderFns } from "./LegalNoticeComp.vue?vue&type=template&id=ea9635aa&scoped=true&"
import script from "./LegalNoticeComp.vue?vue&type=script&lang=ts&"
export * from "./LegalNoticeComp.vue?vue&type=script&lang=ts&"
import style0 from "./LegalNoticeComp.vue?vue&type=style&index=0&id=ea9635aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9635aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
